import { TranslateFn } from 'hooks/useTranslate';
import { Share } from 'types';
import { getEncumbranceLabel } from '../components/PartnerShares/utils/getEncumbranceLabel';

export const getShareEncumbranceNames = (
  share: Share,
  translate: TranslateFn
): string => {
  if (!share?.encumbrances || share.encumbrances.length === 0) {
    return translate('NO_ENCUMBRANCES');
  }

  return share.encumbrances
    .map((encumbrance) =>
      encumbrance?.name ? translate(getEncumbranceLabel(encumbrance)) : null
    )
    .join(', ');
};
